<template>
    <el-dialog
        class="add-shipping-rule-country-selector"
        :visible.sync="countryVisible"
        :close-on-click-modal="true"
        @closed="closeDialog"
        append-to-body
        width="800px"
    >
      <div class="title">Select Country</div>
      <div class="selector-container">
        <div class="selector-container-left">
          <el-input v-model="filter" placeholder="Search Country" size="small" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <label class="check-all"><input type="checkbox" ref="checkAllDom" @click="checkAll"> All</label>
          <div class="selector-container-list">
            <template v-for="item in countries"><label v-if="(!filter || item.label.toLowerCase().includes(filter.toLowerCase()))" :key="item.value"><input type="checkbox" :value="item.value" @click="checkMe" :checked="selected.includes(item.value)"> {{item.label}}</label></template>
          </div>
        </div>
        <div class="selector-container-right">
          <el-input v-model="filterSelected" placeholder="Search Country" size="small" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <div style="margin: 16px 0">Selected: <span style="color:#635cff">{{selected.length}}</span> <span v-if="(selected.length > 1)" style="display: inline-block; margin-left: 10px">(<a href="#" style="color:#635cff" @click="clearAll">Cancel All</a>)</span></div>
          <div class="selector-container-list">
            <template v-for="item in countries">
            <label v-if="(selected.includes(item.value) && (!filterSelected || item.label.toLowerCase().includes(filterSelected.toLowerCase())))" :key="item.value"><input type="checkbox" checked :value="item.value" @click="uncheckMe"> {{item.label}}</label>
            </template>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary"
            @click="save"
                >Confirm</el-button
            >
            <el-button size="small" @click="closeDialog"
                >Cancel</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            filter: '',
            filterSelected: '',
            selected: []
        };
    },
    methods: {
        checkMe(event) {
            const { target } = event
            const { value, checked } = target

            if (!checked) {
                for (let i = 0; i < this.selected.length; i++) {
                    if (this.selected[i] === value) {
                        this.$refs.checkAllDom.checked = false
                        return this.$nextTick(() => this.selected.splice(i, 1))
                    }
                }
            } else {
                this.$nextTick(() => {
                    this.selected.push(value)
                    if (this.selected.length === this.countries.length) {
                        this.$refs.checkAllDom.checked = true
                    }
                })
            }
        },
        uncheckMe(event) {
            const { target } = event
            const { value } = target

            for (let i = 0; i < this.selected.length; i++) {
                if (this.selected[i] === value) {
                    this.$refs.checkAllDom.checked = false
                    return this.$nextTick(() => this.selected.splice(i, 1))
                }
            }
        },
        checkAll(event) {
            const { target } = event
            const { checked } = target

            if (checked) {
                this.selected = this.countries.map(item => item.value.toString())
            } else {
                this.selected = []
            }
        },
        clearAll(event) {
            event.preventDefault()
            this.$nextTick(() => {
                this.$refs.checkAllDom.checked = false
                this.selected = []
            })
        },
        /**
         * 新增窗口关闭
         */
        closeDialog() {
            this.filter = ''
            this.filterSelected = ''
            this.$emit("update:countryVisible", false)
        },
        /**
         *  保存
         */
        save() {
            this.$emit("update:countriesSelected", this.selected)
            this.$emit("update:countryVisible", false)
        },
    },
    props: {
        countryVisible: Boolean,
        tableItem: Object,
        funcName: String,
        countries: Array,
        countriesSelected: Array
    },
    watch: {
        countryVisible: {
            handler() {
                this.selected = [...this.countriesSelected]
            },
            immediate: true,
            deep: true
        }
    },
};
</script>
<style lang="scss">
.add-shipping-rule-country-selector {
    .el-dialog__header {
      display: none;
    }
    .title {
        font-weight: bold;
        margin-top: 10px;
        font-size: 120%;
    }
    .selector-container {
        display: flex;
        justify-content: space-between;
        margin: 20px 0;

        &-left {
            border: 1px solid #DCDFE6;
            padding: 20px;
            height: 300px;
            width: 330px;
            overflow: auto;

            .check-all {
                margin: 16px 0 10px 0;
                display: block;
                user-select: none;
            }
        }

        &-right {
            border: 1px solid #DCDFE6;
            padding: 20px;
            height: 300px;
            width: 330px;
            overflow: auto;
        }

        &-list {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 10px 16px;
            user-select: none;
        }
    }
}
</style>
